export const PriceTypeEnum = {
	subsidized: 'subsidized',
	dual_rate: 'dual_rate',
	regular: 'regular',
};

export const GenderEnum = {
	M: 'M',
	F: 'F',
	O: 'O',
};

export const TeacherTypeEnum = {
	public: 'public',
	state_funded: 'state_funded',
};

export const DocumentTypeEnum = {
	nif: 'nif',
	nie: 'nie',
	passport: 'passport',
};

export const OccupationEnum = {
	agriculture_forestry_fishing: 'agriculture_forestry_fishing', // Farming, forestry, fisheries
	arts_design_media: 'arts_design_media', // Visual arts, performing arts, design, journalism
	science_research: 'science_research', // Scientists, researchers, R&D
	construction: 'construction', // Building, civil works, infrastructure
	education_library: 'education_library', // Teachers, professors, librarians, training
	engineering_technical: 'engineering_technical', // Engineers, architects, technicians
	sports_recreation: 'sports_recreation', // Athletes, trainers, recreation
	manufacturing_production: 'manufacturing_production', // Production, assembly, factory work
	hospitality_tourism: 'hospitality_tourism', // Hotels, restaurants, travel, leisure
	legal_government: 'legal_government', // Lawyers, judges, administration, politics
	military_security: 'military_security', // Armed forces, police, fire services
	mining_energy: 'mining_energy', // Oil, gas, mining, renewable energy
	business_finance: 'business_finance', // Management, marketing, sales, accounting, finance
	skilled_trades: 'skilled_trades', // Mechanics, electricians, carpenters, craft
	healthcare: 'healthcare', // Doctors, nurses, therapists, medical staff
	personal_services: 'personal_services', // Hairdressers, cleaners, childcare, domestic work
	social_services: 'social_services', // Social workers, NGOs, community services
	information_technology: 'information_technology', // Software, IT, networks, data
	transportation_logistics: 'transportation_logistics', // Drivers, pilots, shipping, supply chain
	unemployed_retired: 'unemployed_retired', // Not currently employed
	student: 'student', // Student
	other: 'other', // Other occupations not listed
};

export const LanguageLevelEnum = {
	a1: 'beginner_a1',
	a2: 'elementary_a2',
	b1: 'intermediate_b1',
	b2: 'upper_intermediate_b2',
	c1: 'advanced_c1',
	c2: 'proficient_c2',
	native: 'native',
};

export const LanguageStudyDurationEnum = {
	less_than_6_months: 'less_than_6_months',
	'6_to_12_months': '6_to_12_months',
	'1_to_2_years': '1_to_2_years',
	'2_to_3_years': '2_to_3_years',
	more_than_3_years: 'more_than_3_years',
};
